import { useListSchoolDepartmentsLazyQuery } from '@/types/vue-apollo-helpers';

export const useDepartments = ({
  autoFetch = false,
  first = 10,
  page = 1,
}: { autoFetch?: boolean; first?: number; page?: number } = {}) => {
  const variables = ref({ first, page });

  const {
    result,
    loading,
    refetch,
    load,
    error,
  } = useListSchoolDepartmentsLazyQuery(variables.value);

  if (autoFetch) load();

  const departments = computed(() => result.value?.listSchoolDepartments?.data ?? []);
  const paginatorInfo = computed(() => result.value?.listSchoolDepartments?.paginatorInfo);

  const setPage = async(newPage: number) => {
    variables.value.page = newPage;
    await refetch({ ...variables.value });
  };

  const setItemsPerPage = async(newFirst: number) => {
    variables.value.first = newFirst;
    variables.value.page = 1;
    await refetch({ ...variables.value });
  };

  const reload = async() => {
    await refetch({ ...variables.value });
  };

  return {
    departments,
    paginatorInfo,
    loading,
    error,
    setPage,
    setItemsPerPage,
    reload,
    load,
  };
};
